import usePollingQuery from './usePollingQuery';
import { GET_SHARE_ASSET_SCHEDULE } from 'dashboard-lib/public/emails/emails';
export const useRecurringShareAssets = ({
  objectId,
  objectType,
  deliveryType
}) => {
  const {
    data,
    error,
    loading,
    refetch
  } = usePollingQuery(GET_SHARE_ASSET_SCHEDULE, {
    variables: {
      objectId,
      objectType,
      deliveryType
    },
    fetchPolicy: 'cache-and-network'
  });
  return {
    data: data ? data.emailSchedules : undefined,
    error,
    loading,
    refetch
  };
};